<template>
  <div>
    <self-back :pageHeaderList="[{'name':'月度消耗表'}]"></self-back>
    <div class="content" v-loading='loading'>
      <el-select v-model="status" size="mini" clearable placeholder="请选择" v-if="userInfo.role_id != 10">
        <el-option v-for="(item,index) in statusList" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-table class="table" :header-cell-style="{background:'#f5f7fa'}" :data="accountList" :max-height="tableMaxHeight" border>
        <el-table-column prop="month_desc" label="表名称" align='center' width="200"></el-table-column>
        <el-table-column prop="lock_time" label="媒介锁单时间" align='center' width="200"></el-table-column>
        <el-table-column prop="final_lock_time" label="财务锁单时间" align='center' width="200"></el-table-column>
        <el-table-column align='center' label="状态">
          <template slot-scope="scope">
            {{scope.row.status == 1 ? '财务待锁单' : scope.row.status == 2 ? '已锁单' : '未提交'}}
          </template>
        </el-table-column>
        <el-table-column align='center' label="操作">
          <template slot-scope="scope">
            <button @click="goOrderDetail(scope.row)">订单详情</button>
            <button v-if="userInfo.role_id == 13" :style="scope.row.status == 1||scope.row.status == 2 ? 'background:#BEBEBE;cursor: no-drop;' : 'background:#FC726D'" @click="scope.row.status == 1||scope.row.status == 2?'':lockMonthOrderCaiwu(scope.row,1)">提交财务</button>
            <button v-if="userInfo.role_id == 10" :style="scope.row.status == 2 ? 'background:#BEBEBE;cursor: no-drop;' : 'background:#FC726D'" @click="scope.row.status == 2?'':lockMonthOrderCaiwu(scope.row,2)">锁单</button>
            <button v-if="userInfo.role_id == 10" :style="scope.row.status == 1 ? 'background:#FC726D' : 'background:#BEBEBE;cursor: no-drop;'" @click="scope.row.status == 1?unlockOrder(scope.row):''">撤回锁单</button>
            <button style="background:#FF9B3B" @click="download(scope.row)">导出</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationBox" style="height: 30px;">
        <el-pagination small background :current-page="page" @current-change="handleCurrentChange" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total" />
      </div>
    </div>
    <!-- 零订单提示 -->
    <el-dialog
      title="提示"
      :visible.sync="zeroOrderVisible"
      width="1100px"
      :close-on-click-modal="false"
      >
      <div style="display: flex; align-items: center;">
        <i class="el-icon-warning" style="color: #E6A23C;font-size:18px;margin-right: 6px;"></i>
        <span> 存在 {{ zeroOrder.length }} 条零订单<em v-if="lockData.type == 1">，需要删除后再锁单吗?</em></span>
      </div>

      <ux-grid class="uxGridBox" ref="plxTable" height="550px" :checkboxConfig="{checkMethod: selectable, highlight: true}" @selection-change="selectionChange" show-footer-overflow="tooltip" show-overflow="tooltip" size="mini">
        <!-- <ux-table-column v-if="lockData.type == 1" type="checkbox" align="center" fixed="left" width="40" /> -->
        <ux-table-column v-for="item in columns" :key="item.id" :resizable="item.resizable" :field="item.prop" :title="item.label" :fixed="item.fixed" :width="item.width" show-header-overflow='tooltip' align="center" />
      </ux-grid>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="lockOrderEvent('noDel')" size="mini">不删除并锁单</el-button> -->
        <block v-if="lockData.type == 1">
          <!-- <span style="color: #FF9B3B;font-weight: bold;margin-left: 20px;font-size: 14px;">（已选中 {{ multipleSelection.length }} 条零订单）</span> -->
          <el-button type="primary" @click="lockOrderEvent()" size="mini">删除并锁单</el-button>
        </block>
        <el-button type="primary" v-else @click="lockOrderEvent('cw')" size="mini">锁单</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      accountList: [],
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      statusList: [
        { value: 2, label: '已提交' },
        { value: 1, label: '待财务锁单' },
        { value: 0, label: '未提交' },
      ],
      status: '',
      user_id: '',
      userInfo: {},
      zeroOrderVisible: false,
      zeroOrder: '',
      lockData: {},
      multipleSelection: [],
      columns: [
      { prop: 'order_id', filterMultiple: false, label: '订单ID', fixed: 'left', width: '100', resizable: true },
      { prop: 'task_id', filterMultiple: true, label: '任务ID', fixed: 'left', width: '120', resizable: true },
      { prop: 'month', filterMultiple: false, label: '所属月份', fixed: 'left', width: '100', resizable: true },
      { prop: 'handler', filterMultiple: true, label: '经手人', fixed: '', width: '80', resizable: true },
      { prop: 'company', filters: [], filterMultiple: true, label: '签约公司', fixed: '', width: '80', resizable: true },
      { prop: 'advertiser_account', filterMultiple: true, label: '投放账户', fixed: '', width: '80', resizable: true },
      { prop: 'advertiser_id', filterMultiple: true, label: '投放账户ID', fixed: '', width: '80', resizable: true },
      { prop: 'salesman', filterMultiple: true, label: '销售人员', fixed: '', width: '80', resizable: true },
      { prop: 'final_customer_name', filterMultiple: true, label: '穿透最终客户全称', fixed: '', width: '80', resizable: true },
      { prop: 'customer_name', filterMultiple: true, label: '客户全称', fixed: '', width: '80', resizable: true },
      { prop: 'project_name', filterMultiple: true, label: '项目名称', fixed: '', width: '80', resizable: true },
      { prop: 'launch_platform', filterMultiple: true, label: '投放平台', fixed: '', width: '80', resizable: true },
      { prop: 'media_name', filterMultiple: true, label: '媒体名称', fixed: '', width: '80', resizable: true },
      { prop: 'cost_company_name', filterMultiple: true, label: '成本公司全称', fixed: '', width: '80', resizable: true },
      { prop: 'cost_owner', filterMultiple: true, label: '成本负责人', fixed: '', width: '80', resizable: true },
      { prop: 'internet_celebrity_name', filterMultiple: true, label: '网红昵称', fixed: '', width: '80', resizable: true },
      { prop: 'rebate_expense_receiving_unit', filterMultiple: true, label: '返点支出收款单位', fixed: '', width: '80', resizable: true },
      { prop: 'mcn_user', filterMultiple: true, label: 'mcn负责人', fixed: '', width: '80', resizable: true },
      { prop: 'mcn_handler', filterMultiple: true, label: 'mcn经手人', fixed: '', width: '80', resizable: true },
      { prop: 'final_amount', filterMultiple: true, label: '订单最终收入金额', fixed: '', width: '80', resizable: true },
      { prop: 'cost', filterMultiple: true, label: '订单成本消耗', fixed: '', width: '80', resizable: true },
      { prop: 'mcn_final_amount', filterMultiple: true, label: 'mcn最终收入金额', fixed: '', width: '80', resizable: true },
      ],
    }
  },
  computed: {
    // 计算表格最大高度，确保分页控件可见
    tableMaxHeight() {
      // Header(60) + self-back(50) + padding(30) + select(30) + table-margin(15) + pagination(40) + pagination-margin(15) + footer(70) + footer-margin(10) = 320px
      return window.innerHeight - 260;
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    if (this.userInfo.role_id == 10) {//财务
      this.status = 1;
    }
    this.getOrderMonthList(1)
  },
  methods: {
    unlockOrder (data) {//撤回锁单
      this.$confirm(`确定要将${data.month_desc}撤回锁单吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$axios.post(this.URL.BASEURL + this.URL.unlockOrder, {
          month: data.month,
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.$message({
              message: '撤回成功',
              type: 'success'
            })
            this.getOrderMonthList(this.page)
          } else {
            this.loading = false;
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.loading = false;
        })
      })
    },
    goOrderDetail (data) {//去订单详情
      let routeData = this.$router.resolve({
        path: '/totalTable?month=' + data.month,
      })
      this.$winopen(routeData.href)
    },
    lockOrderEvent(type){// 锁单
      if (type == 'cw'){ // 财务直接锁单，不用删除
        this.$confirm(`确定要将${this.lockData.data.month_desc}锁单吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.lockMonthOrderSecondEvent()
        }).catch(() => {
        });
      } else {
        this.$loading(this.$loadingConfig);
        this.$axios.post(this.URL.BASEURL + this.URL.order_deleteZeroOrder, {
          month: this.lockData.data.month,
          type: this.lockData.type
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.zeroOrderVisible = false;
            this.lockMonthOrderSecondEvent()
          } else {
            this.$loading(this.$loadingConfig).close();
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.$loading(this.$loadingConfig).close();
        })

        // if ( this.multipleSelection && this.multipleSelection.length != 0) {
        //   this.$confirm('确定要删除所选中订单并锁单吗?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(async () => {
        //     this.$loading(this.$loadingConfig);
        //     await this.batchDelete()
        //     this.zeroOrderVisible = false;
        //     this.lockMonthOrderSecondEvent()
        //   })
        // } else {
        //   this.zeroOrderVisible = false;
        //   this.lockMonthOrderSecondEvent()
        // }
      }

    },
    async lockMonthOrderCaiwu (data, type) {//财务锁单
      this.$loading(this.$loadingConfig);
      this.lockData = { data, type };
      // this.zeroOrder = await this.verifyZeroOrder()
      this.$loading(this.$loadingConfig).close();
      // if ( this.zeroOrder && Array.isArray(this.zeroOrder) && this.zeroOrder.length > 0) {
      //   const orderList = await this.getZeroOrderList()
      //   this.zeroOrderVisible = true;
      //   this.$nextTick(()=>{
      //     this.datas = orderList;
      //     this.$refs.plxTable.reloadData(this.datas)
      //   })
      // } else {
        this.$confirm(`确定要将${data.month_desc}锁单吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.lockMonthOrderSecondEvent()
        }).catch(() => {
        });
      // }
    },
    lockMonthOrderSecondEvent () {
      this.$loading(this.$loadingConfig);
      this.$axios.post(this.URL.BASEURL + this.URL.lockMonthOrderSecond, {
        month: this.lockData.data.month,
        type: this.lockData.type
      }).then((res) => {
        this.$loading(this.$loadingConfig).close();
        var res = res.data;
        if (res && res.errno == 0) {
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.getOrderMonthList(this.page)
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close();
      })
    },
    verifyZeroOrder(){ // 查询系统零订单列表
      return new Promise((resolve, reject) => {
        this.$axios.post(this.URL.BASEURL + this.URL.order_verifyZeroOrder, {
          month: this.lockData.data.month,
          type: this.lockData.type
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            resolve(res.rst)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
        })
      })
    },
    getZeroOrderList(){//获取零订单列表
      return new Promise((resolve, reject) => {
        this.$axios.get(this.URL.BASEURL + this.URL.order_zeroOrderList, {
          params:{
            month: this.lockData.data.month,
            type: this.lockData.type
          }
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            resolve(res.rst)
          } else {
            reject()
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          reject()
        })
      })
    },
    handleCurrentChange (val) {
      this.getOrderMonthList(val)
    },
    getOrderMonthList (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.orderMonthList, {
        params: {
          page: page,
          pagesize: this.page_size,
          status: this.status
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    download (data) {//下载
      this.$loading(this.$loadingConfig)
      this.$axios.get(this.URL.BASEURL + this.URL.orderIndexExport, {
        params: {
          month: data.month
        }
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          this.$alert('导出预约成功，请稍后到【导出列表】下载文件！', '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '知道了',
            callback: action => {
            }
          });
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
      // this.$axios.get(this.URL.BASEURL + this.URL.orderIndex, {
      //   params: {
      //     page: 1,
      //     pagesize: 10000,
      //     month: data.month,
      //   }
      // }).then((res) => {
      //   var res = res.data;
      //   this.$loading(this.$loadingConfig).close()
      //   if (res && res.errno == 0) {
      //     if (res.rst && res.rst.data.length > 0) {
      //       this.$exportOrder({ source: 'all', dataList: res.rst.data, name: '消耗表' })
      //     } else {
      //       this.$message({
      //         message: '暂无本月订单！',
      //         type: 'warning'
      //       })
      //     }
      //   } else {
      //     this.$message({
      //       message: res.err,
      //       type: 'warning'
      //     })
      //   }
      // }).catch(() => {
      //   this.$loading(this.$loadingConfig).close()
      // })
    },
    selectable ({ row }) {//选择表格限制条件
      return true
    },
    selectionChange (row) {// 选中的行
      this.multipleSelection = row;
    },
    batchDelete () {//批量删除
      return new Promise((resolve,reject) => {
        var arr = [];
        this.multipleSelection.forEach((item) => {
          arr.push(item.id)
        })
        this.$axios.post(this.URL.BASEURL + this.URL.orderIncomeBatchDel, {
          id_list: arr
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            resolve()
            this.$message({
              message: '删除成功！',
              type: 'success'
            })
          } else {
            reject()
            this.$loading(this.$loadingConfig).close();
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          reject()
          this.$loading(this.$loadingConfig).close();
        })
      })
    },
  },
  watch: {
    status () {
      this.getOrderMonthList(1)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body{
  padding: 6px 20px;
}
/deep/ .el-dialog{
  margin-top: 60px !important;
}
.uxGridBox{
  margin-top: 15px;
}
.content {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
  padding: 15px 15px 15px;
  // display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: calc(100vh - 140px);
  .addaccountButton {
    width: 100px;
    height: 30px;
    background: #5b7bfe;
    border-radius: 4px;
    color: #ffffff;
    font-size: 13px;
    border: none;
  }
  .table {
    width: calc(100% - 30px);
    margin-top: 15px;
    flex: 1;
    min-height: 0;
    button {
      min-width: 60px;
      height: 26px;
      background: #5b7bfe;
      border-radius: 4px;
      color: #ffffff;
      font-size: 12px;
      border: none;
      padding: 0 6px;
    }
  }
  .paginationBox {
    flex-shrink: 0;
    margin-top: 15px;
    padding-bottom: 0;
  }
}
.dialogitem {
  margin-bottom: 20px;
  &:last-of-type {
    margin-bottom: 0;
  }
  label {
    display: inline-block;
    width: 80px;
    color: #202652;
    font-size: 14px;
    line-height: 20px;
    em {
      color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/orderMonthList.vue